import {
  GET_SERVICE_FEES_START,
  GET_SERVICE_FEES_SUCCESS,
  GET_SERVICE_FEES_ERROR,
} from '../../constants';
import { getServiceFees as query } from '../../lib/graphql';
import { getPurchasePlanServiceFees } from '../../lib/graphql/servicePlans';

export const getServiceFees = (listId) => {

  return async (dispatch, getState, { client }) => {

    try {

      dispatch({
        type: GET_SERVICE_FEES_START,
      });

      const { data } = await client.query({ query });

      if (data?.getServiceFees) {
        let guest = {
          type: data.getServiceFees.guestType,
          value: data.getServiceFees.guestValue,
          currency: data.getServiceFees.currency
        };

        let host = {
          type: data.getServiceFees.hostType,
          value: data.getServiceFees.hostValue,
          currency: data.getServiceFees.currency
        };

        const { data: purchasedData } = await client.query({
          query: getPurchasePlanServiceFees,
          variables: { listId },
          fetchPolicy: 'network-only',
        });

        const purchasedResult = purchasedData?.getPurchasePlanServiceFees?.result || {};

        guest = {
          type: purchasedResult.guest?.guestValue >= 0 ? purchasedResult.guest?.guestType : data.getServiceFees.guestType,
          value: purchasedResult.guest?.guestValue >= 0 ? purchasedResult.guest.guestValue : data.getServiceFees.guestValue,
          currency: data.getServiceFees.currency
        };

        host = {
          type: purchasedResult.host?.hostValue >= 0 ? purchasedResult.host?.hostType : data.getServiceFees.hostType,
          value: purchasedResult.host?.hostValue >= 0 ? purchasedResult.host.hostValue : data.getServiceFees.hostValue,
          currency: data.getServiceFees.currency
        };

        dispatch({
          type: GET_SERVICE_FEES_SUCCESS,
          payload: {
            serviceFees: { guest, host }
          }
        });
      }

    } catch (error) {
      dispatch({
        type: GET_SERVICE_FEES_ERROR,
        payload: {
          error
        }
      });
      return false;
    }

    return true;
  };
}